module.exports = __webpack_public_path__ + "static/media/SL_orizzontale.8fab2e38.png";